import { remInPx, remToPx } from './../../../ui';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { Rect } from '../../../platform/geom/Rect';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { ActiveCallFaceInfo } from './ActiveCallFaceInfo';
import { CallMember } from './ActiveCallInfo';

const tryGetAspectRatio = (stream: MediaStream) => {
    for (const t of stream.getVideoTracks()) {
        const ts = t.getSettings();
        if ('aspectRatio' in ts) {
            return ts.aspectRatio;
        }
    }
    return 1;
};

const CallTileFrame = styled.div`
    position: relative;
    border-radius: 50%;
    overflow: hidden; 

    & > div, & > video {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: transform 1000ms cubic-bezier(.65,.09,.55,.94);
        max-width: initial !important;
    }
`;

export type CallTileProps = { id?: string, size: any } & CallMember;

const AudioHandler = React.memo<{ track: MediaStreamTrack }>(({ track }) => {
    const elmt = useRef<HTMLAudioElement>();
    useEffect(() => {
        const stream = new MediaStream([track]);
        elmt.current.srcObject = stream;
    }, [track]);
    return <audio autoPlay playsInline ref={elmt} />;
});

const VideoTransform = (x: number, y: number, s: number) => ({ x, y, s }) as VideoTransform;
interface VideoTransform {
    x: number;
    y: number;
    s: number;
}

const VideoHandler = ({ size, track, face }: { size: string, track: MediaStreamTrack, face?: Rect }) => {

    const elmt = useRef<HTMLVideoElement>();
    const sizePx = remInPx(size);

    const [ready, setReady] = useState(false);
    const [transform, _setTransform] = useState(VideoTransform(0, 0, 1));
    const elmtStyling = useMemo(() => ({
        height: '100%',
        transform: `translate(-50%, -50%) translate(${transform.x}px, ${transform.y}px) scale(${transform.s})`,
    }), [transform]);

    // useEffect(() => {
    //     if (!ready) return;

    //     const frame = new Rect(0, 0, elmt.current.width, elmt.current.height);
    //     console.log(frame.toString());
    //     let absFace = frame;

    //     if (face) {
    //         face = face.inflate([face.width * 0.2, face.height * 0.2]);
    //         absFace = new Rect(face.left * frame.width, face.top * frame.height, face.width * frame.width, face.height * frame.height);
    //         // absFace = absFace.inflate(20).offset([0, -20]);
    //         absFace = absFace.clamp(frame);
    //     }

    //     console.log(remToPx(size), frame.height);

    //     const scale = frame.height / absFace.height;
    //     const offset = frame.center().subtract(absFace.center());

    //     console.log(scale, offset.toString());

    //     const prev = transform;
    //     const next = VideoTransform(offset.x, offset.y, scale);

    //     if (prev.x !== next.x || prev.y !== next.y || prev.s !== next.s) {
    //         setTransform(next);
    //     }

    // }, [ready, face]);

    useEffect(() => {
        const stream = new MediaStream([track]);
        const ratio = tryGetAspectRatio(stream);
        console.log(ratio);
        // elmt.current.width = sizePx * ratio;
        // elmt.current.height = sizePx;
        elmt.current.srcObject = stream;
        setReady(true);
    }, [track]);

    return <>
        <video style={elmtStyling} autoPlay muted playsInline ref={elmt} />
    </>;
};

export const LocalCallTile = ({ size, videoTrack }: CallTileProps) => {

    const { area: face } = useEditorSessionObserver(ActiveCallFaceInfo);
    const styling = {
        width: remToPx(size),
        height: remToPx(size),
    };

    return <CallTileFrame style={styling}>
        {videoTrack && videoTrack.state === 'playable' && (
            <VideoHandler size={size} track={videoTrack.track} face={face} />
        )}
    </CallTileFrame>;
};

export const PeerCallTile = React.memo<CallTileProps & { face?: Rect }>(({ size, audioTrack, videoTrack, face }) => {

    const styling = {
        width: remToPx(size),
        height: remToPx(size),
    };

    return <CallTileFrame style={styling}>
        {videoTrack && videoTrack.state === 'playable' && (
            <VideoHandler size={size} track={videoTrack.track} face={face} />
        )}
        {audioTrack && audioTrack.state === 'playable' && (
            <AudioHandler track={audioTrack.track} />
        )}
    </CallTileFrame>;
});
